import { EXPERIMENT_STATUS_FILTER } from 'modules/experiments/constants';
import { useTableFacetContext } from 'modules/experiments/contexts';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { Tab, TabGroup } from 'ui/tabs';

export const StateTabs = () => {
  const { t } = useExperimentsTranslations();
  const { selectedTab, setSelectedTab } = useTableFacetContext();

  return (
    <TabGroup selectedTab={selectedTab.join()} data-test="experiments-index-state-tabs">
      {EXPERIMENT_STATUS_FILTER.map(({ id, label }) => (
        <Tab
          key={id.join()}
          id={id.join()}
          onClick={() => {
            setSelectedTab(id);
          }}
        >
          {t(label)}
        </Tab>
      ))}
    </TabGroup>
  );
};
